/**
 * Voorstel voor een gedeeld toegangswachtwoord.
 *
 * Bewust leesbaar in plaats van willekeurige tekens: dit wachtwoord wordt
 * gemaild, doorgebeld en overgetypt. Drie woorden plus twee cijfers uit een
 * lijst van 64 geeft ~20 bits per woord — ruim genoeg voor een slot dat
 * bovendien server-side gethrottled is, en oneindig veel beter dan het
 * "Voorjaar2026" dat mensen anders zelf verzinnen.
 *
 * Gebruikt crypto.getRandomValues (niet Math.random): dat is de enige bron
 * die je voor iets wachtwoordachtigs mag gebruiken.
 */

const WORDS = [
  'anchor', 'amber', 'atlas', 'bamboo', 'beacon', 'birch', 'bridge', 'canyon',
  'cedar', 'cobalt', 'comet', 'copper', 'coral', 'cotton', 'crater', 'delta',
  'ember', 'falcon', 'fern', 'forest', 'garnet', 'glacier', 'granite', 'harbor',
  'hazel', 'indigo', 'ivory', 'jasper', 'juniper', 'kettle', 'lagoon', 'lantern',
  'linen', 'marble', 'meadow', 'mint', 'nectar', 'nimbus', 'oak', 'olive',
  'onyx', 'opal', 'orbit', 'pebble', 'pepper', 'pine', 'plum', 'prairie',
  'quartz', 'quill', 'raven', 'ridge', 'river', 'saffron', 'sage', 'sierra',
  'slate', 'summit', 'thistle', 'topaz', 'tundra', 'velvet', 'willow', 'zinc',
]

function randomIndex(max: number): number {
  const buffer = new Uint32Array(1)
  crypto.getRandomValues(buffer)
  return buffer[0] % max
}

export function generatePassphrase(): string {
  const words = Array.from({ length: 3 }, () => WORDS[randomIndex(WORDS.length)])
  const digits = String(randomIndex(90) + 10)

  return `${words.join('-')}-${digits}`
}
